import i18n from '../i18n';

export function ORDER_TYPE(type) {
  const TYPES = {
    MARKET: i18n.t('common_market'),
    LIMIT: i18n.t('common_limit')
  };
  const translated = TYPES[type];
  if (!translated) {
    console.error(`ORDER_TYPE: ${type} not found for translation.`); // eslint-disable-line
    return type;
  }

  return translated;
}
